import React from 'react';
import { colors, radius } from '../theme';

// Menu "Video panjang" (2026-10-25): satu pintu untuk tiga jenis video panjang. Hanya mengarahkan ke halaman
// yang sudah ada — Kompilasi = halaman UGC (tidak diubah), Video musik & Narasi = halaman Video Lirik
// (Starhub Studio sebagai alat render), Upload video jadi = halaman UGC.
const JENIS = [
  {
    key: 'musik', icon: 'ti-player-play', judul: 'Video panjang',
    isi: 'Satu video utuh, atau satu video musik dari 1 lagu. Lirik boleh diisi, boleh juga tanpa lirik.',
    tag: ['Video musik', 'Upload video jadi'],
    aksi: [['musik', 'Buat video musik'], ['upload', 'Upload video jadi']],
  },
  {
    key: 'narasi', icon: 'ti-microphone-2', judul: 'Video narasi',
    isi: 'Teks dibacakan suara AI dengan teks berjalan di layar.',
    tag: ['Suara AI', 'Bisa diterjemahkan'],
    aksi: [['narasi', 'Buat video narasi']],
  },
  {
    key: 'kompilasi', icon: 'ti-playlist', judul: 'Kompilasi (playlist)',
    isi: 'Banyak lagu disusun jadi satu video playlist dengan latar dan chapter.',
    tag: ['Banyak lagu', 'Diproses di server'],
    aksi: [['kompilasi', 'Buat kompilasi']],
  },
];

// Tombol/kartu mengikuti fitur rinci klien (2026-10-25): kartu tanpa tombol aktif disembunyikan.
const KUNCI_AKSI = { musik: 'video_musik', upload: 'ugc_upload', narasi: 'narasi', kompilasi: 'ugc_kompilasi' };

export default function VideoPanjangHub({ onPilih, fiturOn = () => true }) {
  const kartu = JENIS.map(j => ({ ...j, aksi: j.aksi.filter(([k]) => fiturOn(KUNCI_AKSI[k])) })).filter(j => j.aksi.length);
  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: colors.textPrimary, margin: 0 }}>Video panjang</h1>
      <div style={{ fontSize: 13, color: colors.textSecondary, marginTop: 4, marginBottom: 16 }}>
        Pilih jenis video panjang yang mau kamu buat. Hasilnya masuk ke daftar video UGC, siap dipilihkan channel & jadwal.
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 14 }}>
        {kartu.length === 0 && <div style={{ fontSize: 13, color: colors.textSecondary }}>Belum ada jenis video panjang yang aktif untuk akun ini. Hubungi admin untuk mengaktifkan fitur ini.</div>}
        {kartu.map(j => (
          <div key={j.key} style={{ background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg, padding: 18, display: 'flex', flexDirection: 'column', gap: 10 }}>
            <i className={`ti ${j.icon}`} style={{ fontSize: 28, color: colors.accent }} aria-hidden="true" />
            <div style={{ fontSize: 16, fontWeight: 700, color: colors.textPrimary }}>{j.judul}</div>
            <div style={{ fontSize: 13, color: colors.textSecondary, lineHeight: 1.5 }}>{j.isi}</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {j.tag.map(t => <span key={t} style={{ fontSize: 11, padding: '3px 8px', borderRadius: 999, background: colors.bgCardMuted, color: colors.textSecondary }}>{t}</span>)}
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 'auto', paddingTop: 4 }}>
              {j.aksi.map(([k, label], i) => (
                <button key={k} type="button" onClick={() => onPilih(k)} className={i === 0 ? 'btn btn-gold' : 'btn btn-outline'} style={{ fontSize: 13 }}>
                  {label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// Tautan kembali ke pilihan jenis, dipasang Dashboard di atas halaman UGC / Video Lirik (halamannya sendiri tidak diubah).
export function KembaliKeVideoPanjang({ onKembali }) {
  return (
    <button type="button" onClick={onKembali}
      style={{ background: 'transparent', border: 'none', padding: 0, marginBottom: 12, fontSize: 13, color: colors.textSecondary, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <i className="ti ti-arrow-left" aria-hidden="true" />Semua jenis video panjang
    </button>
  );
}
